const styles = ({ COLORS }) => ({
  container: {
    padding: 0
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    '& p': {
      fontWeight: 'bold'
    }
  },
  content: {
    padding: '10px 20px 20px'
  },
  alert: {
    margin: '20px 20px 0'
  },
  remaining: {
    padding: '10px 20px',
    background: '#f9f9f9',
    borderBottom: '1px solid #ececec'
  },
  avatar: {
    fontSize: '30px',
    marginRight: '10px'
  },
  details: {
    listStyle: 'none',
    fontSize: '16px',
    margin: 0,
    '& li': {
      marginBottom: '6px'
    }
  },
  selection: {
    borderTop: '1px solid #e5e5e5',
    paddingTop: '30px',
    marginTop: '30px'
  },
  processing: {
    opacity: '0.7',
    pointerEvents: 'none'
  },
  choice: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    '& label': {
      marginLeft: '10px'
    }
  },
  field: {
    width: '50%',
    height: '40px',
    border: '1px solid #ddd',
    padding: '10px 15px',
    borderRadius: '4px',
    color: '#999',
    marginTop: '10px',
    '&::placeholder': {
      color: '#bbb'
    }
  },
  menu: {
    background: '#fff',
    boxShadow: '0 0 4px rgba(0,0,0,0.2)',
    position: 'absolute',
    width: '50%',
    zIndex: '100'
  },
  item: {
    padding: '5px 15px'
  },
  highlighted: {
    background: COLORS.BLUE.NORMAL,
    color: '#fff',
    cursor: 'pointer'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})

export default styles
